module.exports = __webpack_public_path__ + "media/bootstrap-icons/hdd-b9560a8c.svg";